import NextImage from "@/app/components/lib/NextImage";
import { Link } from "@/app/components/lib/navigation/Link";
import { PagesPaths } from "@/utils/functions/pages-paths";

interface props {
  title: string;
  date?: string;
  action?: React.ReactNode;
  actionAlign?: "start" | "end";
  imgSrc: string;
  direction: "horazonal" | "vertical";
  withBorder: boolean;
  id: number;
  slug: string;
  imageSize?: {
    width: number;
    height: number;
  };
}
const BlogMiniCard: React.FC<props> = ({
  title,
  date,
  action,
  actionAlign,
  imgSrc,
  direction,
  withBorder,
  slug,
  imageSize,
}) => {
  const containerClassName = `blog-mini-card  ${
    direction === "vertical" ? "vertical " : ""
  }  ${withBorder ? "with-border " : ""}`;
  return (
    <li className={containerClassName} id="blog-card">
      <div className="image">
        <Link prefetch={false} href={PagesPaths?.blogDetails + slug}>
          <NextImage
            width={
              imageSize ? imageSize?.width : direction !== "vertical" ? 89 : 135
            }
            height={
              imageSize ? imageSize?.height : direction !== "vertical" ? 60 : 78
            }
            objectFit="cover"
            src={imgSrc}
            alt={"Bimg"}
          />
        </Link>
      </div>
      <div className={`content w-100 `}>
        <Link prefetch={false} href={PagesPaths?.blogDetails + slug}>
          <h3 className="title">{title}</h3>
        </Link>
        {date && <span className="date">{date}</span>}
        <div
          className={`w-100 d-flex align-items-center ${
            actionAlign === "end" ? "justify-content-end" : ""
          } `}
          style={{ height: 32 }}
        >
          {action}
        </div>
      </div>
    </li>
  );
};

export default BlogMiniCard;
